<div class="nSrch">
  <form>
    <input
      type="text"
      class="form-control"
      placeholder="{{ 'Enter Your Email' | translate }}"
    />
    <button>{{ "Subscribe Now" | translate }}</button>
  </form>
</div>
